import styled from 'styled-components';

export interface ITableStyleWrapper {
  headerBackgroundColor?: string;
}

export const TableStyleWrapper = styled.div<ITableStyleWrapper>`
  width: 100%;
  height: 100%;

  .BaseTable {
    box-shadow: none;
  }
  .BaseTable__table-main {
    outline: none;
  }
  .BaseTable__header {
    height: auto !important;
  }
  .BaseTable__header > * {
    height: auto !important;
  }
  .BaseTable__header-row {
    height: auto !important;
    background-color: ${(props) =>
      props.headerBackgroundColor ? props.headerBackgroundColor : '#fff'};
  }
  .BaseTable__header-row,
  .BaseTable__row {
    align-items: flex-start;
  }
  .BaseTable__header-cell-text {
    font-weight: 400;
    font-size: 11px;
    line-height: 12px;
    color: #949494;
  }
  .BaseTable__row:hover,
  .BaseTable__row--hovered {
    background-color: transparent;
  }
  .BaseTable__empty-layer {
    display: none !important;
  }
`;
